const axios = require('axios')
const API_END_POINT = window._env.host.bhuntrApi
const BUILDER = API_END_POINT + '/builder'
const COMPETITIONS = API_END_POINT + '/competitions'

import { generateResponse, generateErrorResponse } from './common'

export default {
  API_END_POINT: API_END_POINT,
  submitComment (token, data) {
    let options = {
      url: COMPETITIONS + '/comments/' + data.contestId + '/' + data.contestContentId,
      method: 'post',
      data: data
    }
    if (typeof token !== 'undefined' && token !== '') {
      options.headers = {
        Authorization: 'Bearer ' + token
      }
    }
    return axios(options).then(generateResponse, generateErrorResponse)
  },
  getComments (token, data) {
    let url = COMPETITIONS + '/comments/' + data.contestId + '/' + data.contestContentId
    if (typeof data.parent !== 'undefined') {
      if (data.parent > 0) {
        url = COMPETITIONS + '/subcomments/' + data.contestId + '/' + data.contestContentId + '/' + data.parent
      }
    }
    if (typeof token !== 'undefined') {
      return axios({
        method: 'get',
        url: url,
        params: data,
        headers: {
          Authorization: 'Bearer ' + token
        }
      }).then(generateResponse, generateErrorResponse)
    } else {
      return axios({
        method: 'get',
        url: url,
        params: data
      }).then(generateResponse, generateErrorResponse)
    }
  },
  get (token, locale = 'tw', alias) {
    if (locale.trim() === '') {
      locale = 'tw'
    }
    if (typeof token !== 'undefined') {
      return axios({
        method: 'get',
        url: BUILDER + '/get/' + locale + '/' + alias,
        headers: {
          Authorization: 'Bearer ' + token
        }
      }).then(generateResponse, generateErrorResponse)
    } else {
      return axios({
        method: 'get',
        url: BUILDER + '/get/' + locale + '/' + alias
      }).then(generateResponse, generateErrorResponse)
    }
  }
}



// WEBPACK FOOTER //
// ./src/api/builder.js